var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.4277 10.0092L19.761 4.64726C17.581 2.89462 14.4184 2.89596 12.237 4.64726L5.57035 10.0092C4.14902 11.1523 3.33301 12.8542 3.33301 14.6789V22.6711C3.33301 25.9776 6.02501 28.6666 9.33301 28.6666H12.6663V22.6711C12.6663 20.8358 14.1623 19.3419 15.9997 19.3419C17.837 19.3419 19.333 20.8358 19.333 22.6711V28.6666H22.6663C25.9743 28.6666 28.6663 25.9776 28.6663 22.6711V14.6789C28.6663 12.8542 27.8503 11.1523 26.4277 10.0092ZM27.333 22.6711C27.333 25.2413 25.2397 27.3328 22.6663 27.3328H20.6663V22.6711C20.6663 20.0995 18.573 18.0081 15.9997 18.0081C13.4263 18.0081 11.333 20.0995 11.333 22.6711V27.3328H9.33301C6.75967 27.3328 4.66634 25.2413 4.66634 22.6711V14.6789C4.66634 13.261 5.30102 11.9379 6.40635 11.0482L13.073 5.68633C14.769 4.32317 17.2317 4.3245 18.9263 5.68633L25.593 11.0482C26.6997 11.9379 27.333 13.261 27.333 14.6789V22.6711Z",
    fill: "#10CAFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeBlue);
export default __webpack_public_path__ + "static/media/home-blue.42f13139e1959609a92362ae6671d206.svg";
export { ForwardRef as ReactComponent };